import { FeedImportRequest } from '@app/models/feed_imports/FeedimportRequest';
import {
  FeedImportTableData,
  FeedImportTableRow,
  FeedImportResponse,
  FeedImportApiData,
  Parameters,
} from '@app/models/feed_imports/FeedImportResponse';
import { post, get } from './http.api';

export const getFeedImportData = async (parameters: Parameters): Promise<FeedImportTableData> => {
  try {
    const { data, status } = await get<any>(
      'feed_importations',
      {
        params: parameters,
      },
      true,
    );
    console.log(`Status: ${status}`, `Data:`, data);
    const feedImports: FeedImportTableRow[] = data.pr_feed_importations.data.map((feedData: any) => ({
      id: feedData.id,
      year: feedData.year,
      status: feedData.status,
    }));

    return {
      data: feedImports,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching Expected Ingredients:', error);
    throw error;
  }
};

export const getAllFeedImports = async (): Promise<FeedImportResponse> => {
  try {
    const { data, status } = await get<FeedImportResponse>(`feed_importations`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getFeedImportById = async (id: number): Promise<FeedImportResponse> => {
  try {
    const { data, status } = await get<FeedImportResponse>(`feed_importations/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeFeedImport = async (feedData: FeedImportRequest) => {
  try {
    const response = await post<any>('feed_importations/create', feedData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createFeedImport = async (): Promise<FeedImportApiData> => {
  try {
    const { data, status } = await get<FeedImportApiData>(`feed_importations/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showFeedImport = async (id: number) => {
  try {
    const { data, status } = await get<FeedImportApiData>(`feed_importations/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editFeedImport = async (id: number) => {
  try {
    const { data, status } = await get<FeedImportApiData>(`feed_importations/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateFeedImport = async (id: number, UpdateFeedImport: FeedImportRequest) => {
  try {
    const { data, status } = await post<FeedImportRequest>(
      `feed_importations/${id}/edit`,
      UpdateFeedImport,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
